import { FC } from 'react'

import { getRouteApi } from '@tanstack/react-router'
import { BankAccountSelect, CompanySelect, ContactSelect, FF, LicenseSelect, Validators } from 'ui/components'

import { SelectsForNewDocumentProps } from './SelectsForNewDocument.types'

const routeApi = getRouteApi('/_app/documents/new')

export const SelectsForNewDocument: FC<SelectsForNewDocumentProps> = ({ form }) => {
  const {
    bankAccountId,
    companyId,
    contactId,
    licenseId,
    subjectType: currentSubject,
    subjectName
  } = routeApi.useSearch()

  const getDefaultSelectOption = (subjectType: string, value?: number) =>
    currentSubject === subjectType ? (subjectName && value ? { value, label: subjectName } : undefined) : undefined

  return (
    <form.Subscribe
      children={({ values: { subjectType } }) => (
        <>
          {subjectType === 'license' && (
            <form.Field
              name="licenseId"
              validators={{
                onSubmitAsync: ({ value }) => Validators.required.field(value)
              }}
              children={(licenseField) => (
                <FF
                  label="License"
                  field={licenseField}
                  required
                  input={(props) => (
                    <LicenseSelect
                      emptyOption={getDefaultSelectOption(subjectType, licenseId)}
                      data-qa="License"
                      {...props}
                    />
                  )}
                />
              )}
            />
          )}
          {subjectType === 'company' && (
            <form.Field
              name="companyId"
              validators={{
                onSubmitAsync: ({ value }) => Validators.required.field(value)
              }}
              children={(companyField) => (
                <FF
                  label="Relationship"
                  field={companyField}
                  required
                  input={(props) => (
                    <CompanySelect
                      hideMyCompaniesFilter
                      options-data-qa="Relationships"
                      data-qa="Relationships Type"
                      defaultOption={getDefaultSelectOption(subjectType, companyId)}
                      {...props}
                    />
                  )}
                />
              )}
            />
          )}
          {subjectType === 'bank_account' && (
            <form.Field
              name="bankAccountId"
              validators={{
                onSubmitAsync: ({ value }) => Validators.required.field(value)
              }}
              children={(bankAccountIdField) => (
                <FF
                  label="Bank Account"
                  field={bankAccountIdField}
                  required
                  input={(props) => (
                    <BankAccountSelect
                      defaultOption={getDefaultSelectOption(subjectType, bankAccountId)}
                      data-qa="Bank Account"
                      {...props}
                    />
                  )}
                />
              )}
            />
          )}
          {subjectType === 'contact' && (
            <form.Field
              name="contactId"
              validators={{
                onSubmitAsync: ({ value }) => Validators.required.field(value)
              }}
              children={(contactIdField) => (
                <FF
                  label="Contact"
                  field={contactIdField}
                  input={(props) => (
                    <ContactSelect
                      emptyOption={getDefaultSelectOption(subjectType, contactId)}
                      data-qa="Contact"
                      {...props}
                    />
                  )}
                />
              )}
            />
          )}
        </>
      )}
    />
  )
}
